import { Action, bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { RootState } from "../reducers";
import {
  getUsers,
  createUser,
  updateUser,
  deleteUser,
  sendWelcomeEmail as sendWelcomeEmailAction,
} from "../actions";

export const useUsersState = () => {
  return useSelector((state: RootState) => state.users);
};

export const useUsersDispatch = () => {
  const dispatch =
    useDispatch<ThunkDispatch<RootState, unknown, Action<string>>>();
  return {
    ...bindActionCreators(
      { getUsers, createUser, updateUser, deleteUser },
      dispatch
    ),
    sendWelcomeEmail: (userId: string) =>
      dispatch(sendWelcomeEmailAction(userId)),
  };
};
